import { registerBlockType } from '@wordpress/blocks';
import { InspectorControls, useBlockProps, RichText } from '@wordpress/block-editor';
import { PanelBody, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import metadata from './block.json';

const Edit = ({ attributes, setAttributes }) => (
  <>
    <InspectorControls>
      <PanelBody title="Settings">
        <TextControl
          label="Product Category"
          value={attributes.category}
          onChange={(val) => setAttributes({ category: val })}
        />
      </PanelBody>
    </InspectorControls>
    <div {...useBlockProps()}>
                <h3>{__('Monfort Products')}</h3>
                <p>{__('Preview not generated for dynamic blocks.', 'monfort')}</p>
            </div>
  </>
);

registerBlockType(metadata.name, {
  ...metadata,
  edit: Edit,
  save: () => null,
});
